// Catálogo único de eBooks. Lido por ShopPage (grid), ProductDetails (detalhe) e
// qualquer outro consumidor que precise dos metadados de um produto.
// A ordem desta lista é a ordem visual da loja (`/loja`).
export const PRODUCTS_DATABASE = [
  {
    id: 'colecao-completa-13-1',
    title: 'COLEÇÃO COMPLETA: 13 EM 1',
    price: 7990,
    originalPrice: 14990,
    image: '/capaEbooksLoja/colecaocompleta.png',
    category: 'Coleções',
    rating: 4.8,
    reviews: 128,
    description:
      'Este e-book é a união de todos os 13 e-books. Ao total, são mais de 500 cifras, separadas por tempo litúrgico, por categorias (canto de entrada, ato penitencial, glória, etc), músicas Marianas, músicas para Adoração, músicas mais conhecidas, músicas que nos marcaram, músicas para grupo de oração e muito mais!',
    fullDescription: `
      <h3>O que você ganha com essa coleção:</h3>
      <ul>
        <li>✓ 500+ cifras simplificadas</li>
        <li>✓ Vídeo aulas no canal </li>
        <li>✓ Organização por tempo litúrgico</li>
        <li>✓ Categoria personalizada</li>
        <li>✓ Acesso vitalício </li>
        <li>✓ Suporte direto</li>
      </ul>
    `,
    quantity: 0,
  },
  {
    id: 'tablaturas',
    title: 'Tablaturas católicas para Fingerstyle',
    price: 3990,
    originalPrice: 5990,
    image: '/capaEbooksLoja/fingerstyle.png',
    category: 'Técnica',
    rating: 4.7,
    reviews: 145,
    description: '20 tablaturas especiais para se tocar no Fingerstyle.',
    fullDescription: `
      <h3>Músicas Disponíveis</h3>

      <h4>🎵 Fáceis:</h4>
      <ul>
        <li>Mãezinha do céu</li>
        <li>Maria de Nazaré</li>
        <li>Pelos prados e campinas</li>
        <li>Povo de Deus foi assim</li>
        <li>Sou bom pastor</li>
        <li>Vem, eu mostrarei</li>
      </ul>

      <h4>🎵 Intermediárias:</h4>
      <ul>
        <li>A minh'alma abrirei</li>
        <li>A treze de maio</li>
        <li>Cantar a beleza da vida</li>
        <li>Como a ovelha perdida</li>
        <li>Como és lindo</li>
        <li>Eu vim para que todos tenham vida</li>
        <li>Noite feliz</li>
        <li>Pelas estradas da vida</li>
        <li>Romaria</li>
        <li>Tão sublime sacramento</li>
      </ul>

      <h4>🎵 Avançadas:</h4>
      <ul>
        <li>Buscai primeiro</li>
        <li>Eu navegarei</li>
        <li>Prova de amor maior não há</li>
        <li>Vejam, eu andei pelas vilas</li>
      </ul>
    `,
    quantity: 0,
  },
  {
    id: 'cifras-advento',
    title: 'Cifras de Músicas - Advento',
    price: 1790,
    originalPrice: 1599,
    image: '/capaEbooksLoja/musicasAdvento.png',
    category: 'Litúrgico',
    rating: 4.7,
    reviews: 172,
    description: 'Cifras especiais para o período do Advento.',
    fullDescription: `
      <h3>Entradas (18 músicas)</h3>
      <ul>
        <li>Senhor, vem salvar teu povo</li>
        <li>Vigia esperando aurora</li>
        <li>Ó, vinde, enfim, eterno Deus</li>
        <li>Que santidade de vida</li>
        <li>O Senhor está pra chegar</li>
        <li>Vinde, Senhor, visitar vosso povo</li>
        <li>O Senhor virá libertar o seu povo</li>
        <li>Eis que de longe vem o Senhor</li>
        <li>Vem, Senhor, nos salvar</li>
        <li>Abre as portas</li>
        <li>Vem, Senhor</li>
        <li>Reinará sobre nós</li>
        <li>Preparai o caminho</li>
        <li>O Cristo Senhor vai chegar</li>
        <li>Ouve-se na terra um grito</li>
        <li>A vós, meu Deus</li>
        <li>Povo de Sião</li>
        <li>Alegrai-vos sempre no Senhor</li>
      </ul>
      <h3>Ofertório (5 músicas)</h3>
      <ul>
        <li>A nossa oferta apresentamos neste altar</li>
        <li>Muitos suspiram por Ti</li>
        <li>Nasceu em Belém a casa do pão</li>
        <li>É dom de amor</li>
        <li>Ó vem, ó vem, Emanuel</li>
      </ul>
      <h3>Comunhão (10 músicas)</h3>
      <ul>
        <li>Ouço uma voz</li>
        <li>Jerusalém, povo de Deus</li>
        <li>Vigiai, eu vos digo</li>
        <li>Vigiai, diz Jesus, vigiai</li>
        <li>Vem, ó, Senhor, com o Teu povo caminhar</li>
        <li>Abre tua porta que alguém está nascendo</li>
        <li>Alegrai-vos, Ele está bem perto</li>
        <li>Deus conosco, Emanuel</li>
        <li>Levanta-te, Jerusalém</li>
        <li>O Senhor vem ao nosso encontro</li>
      </ul>
    `,
    quantity: 0,
  },
  {
    id: 'cifras-natal',
    title: 'Cifras de Músicas - Natal',
    price: 1790,
    originalPrice: 1599,
    image: '/capaEbooksLoja/musicasnatal.png',
    category: 'Litúrgico',
    rating: 4.8,
    reviews: 189,
    description: 'Cifras natalinas especiais para este tempo litúrgico.',
    fullDescription: `
      <h3>Entradas (5 músicas)</h3>
      <ul>
        <li>Nasceu-nos hoje um menino</li>
        <li>É natal de Jesus</li>
        <li>Noite excelsa</li>
        <li>Vinde, Cristãos</li>
        <li>Nas terras do oriente</li>
      </ul>
      <h3>Ofertório (4 músicas)</h3>
      <ul>
        <li>Sobe a Jerusalém</li>
        <li>Entre nós quis morar</li>
        <li>Bendito sejais pelo verbo que se fez carne</li>
        <li>Cristãos, vinde todos</li>
      </ul>
      <h3>Comunhão (5 músicas)</h3>
      <ul>
        <li>No presépio pequenino</li>
        <li>Da cepa brotou a rama</li>
        <li>Hino ao verbo de Deus</li>
        <li>O verbo se fez carne</li>
        <li>Manjedoura trás surpresa</li>
      </ul>
      <h3>Extras (7 músicas)</h3>
      <ul>
        <li>Kalenda de Natal</li>
        <li>Noite feliz</li>
        <li>Bate o sino</li>
        <li>É natal</li>
        <li>Então é natal</li>
        <li>Calix bento</li>
        <li>Ouro, incenso e mirra</li>
      </ul>
    `,
    quantity: 0,
  },
  {
    id: 'cifras-quaresma',
    title: 'Cifras de Músicas - Quaresma',
    price: 1790,
    originalPrice: 1599,
    image: '/capaEbooksLoja/musicasquaresma.png',
    imageFocus: '50% 8%',
    imageFocusMobile: '50% 0%',
    imageMobileFit: 'contain',
    category: 'Litúrgico',
    rating: 4.7,
    reviews: 156,
    description: 'Cifras especiais para o período da Quaresma.',
    fullDescription: `
      <h3>Entradas (11 músicas)</h3>
      <ul>
        <li>Lembra, Senhor, do teu amor fiel para sempre</li>
        <li>Rejubila-te, cidade santa</li>
        <li>Acolhe, ó Deus, o nosso pranto</li>
        <li>Volta, meu povo, ao Teu Senhor</li>
        <li>Senhor, eis aqui o teu povo</li>
        <li>Eis o tempo de conversão</li>
        <li>Desta vez é pra valer</li>
        <li>Fala assim, meu coração</li>
        <li>Hosana hei</li>
        <li>Nós nos gloriamos</li>
        <li>Quanto a nós, devemos gloriar-nos na cruz</li>
      </ul>
      <h3>Evangelho (9 músicas)</h3>
      <ul>
        <li>Salve, ó Cristo, obediente</li>
        <li>Louvor a vós, ó Cristo rei</li>
        <li>Eu vim para escutar</li>
        <li>Eu vos dou um novo mandamento</li>
        <li>Palavra de salvação</li>
        <li>Louvor e glória a ti, Senhor</li>
        <li>Louvor, honra, glória e poder</li>
        <li>Glória e louvor a Cristo</li>
        <li>Fala, Senhor</li>
      </ul>
      <h3>Ofertório (13 músicas)</h3>
      <ul>
        <li>Sê bendito, Senhor, para sempre</li>
        <li>Escuta, Senhor</li>
        <li>Recebe, Deus amigo</li>
        <li>Se o grão de trigo não morrer</li>
        <li>Teu sou</li>
        <li>Sabes, Senhor</li>
        <li>O vosso coração de pedra</li>
        <li>Todo povo sofredor</li>
        <li>Daqui do meu lugar</li>
        <li>Mãos abertas</li>
        <li>Este pranto em minhas mãos</li>
        <li>Ó morte estás vencida</li>
        <li>Onde o amor e a caridade</li>
      </ul>
      <h3>Comunhão (6 músicas)</h3>
      <ul>
        <li>Agora o tempo se cumpriu</li>
        <li>Então da nuvem luminosa</li>
        <li>Prova de amor maior não há</li>
        <li>Eu vim para que todos tenham vida</li>
        <li>Criai em nós um coração</li>
        <li>Eu quis comer esta ceia agora</li>
      </ul>
      <h3>Extras (7 músicas)</h3>
      <ul>
        <li>Belíssimo Esposo</li>
        <li>Pecador agora é tempo</li>
        <li>A morrer crucificado</li>
        <li>Via Sacra (Kelly Patrícia)</li>
        <li>Converter ao Evangelho</li>
        <li>Hosana ao Filho de Davi</li>
        <li>Jesus erguendo-se da ceia</li>
      </ul>
    `,
    quantity: 0,
  },
  {
    id: 'cifras-pascoal',
    title: 'Cifras de Músicas - Páscoa',
    price: 1790,
    originalPrice: 1599,
    image: '/capaEbooksLoja/musicaspascoa.png',
    imageFocus: '50% 18%',
    imageFocusMobile: '50% 0%',
    imageMobileFit: 'contain',
    category: 'Litúrgico',
    rating: 4.7,
    reviews: 134,
    description: 'Seleção especial de músicas pascais. Cristo ressuscitou!',
    fullDescription: `
      <h3>Entradas (11 músicas)</h3>
      <ul>
        <li>Porque Ele vive</li>
        <li>O Senhor ressurgiu</li>
        <li>Ressuscitou – Shalom</li>
        <li>Sou bom pastor</li>
        <li>Cristo ressuscitou, aleluia</li>
        <li>Por sua morte</li>
        <li>O Senhor ressuscitou, aleluia</li>
        <li>Tempo de celebrar</li>
        <li>Jesus Cristo, nossa páscoa</li>
        <li>Louvores entoemos</li>
        <li>Faço novas todas as coisas</li>
      </ul>
      <h3>Ofertório (4 músicas)</h3>
      <ul>
        <li>Bendito sejas</li>
        <li>Eu creio num mundo novo</li>
        <li>Ao celebrar nossa páscoa</li>
        <li>As nossas ofertas de vinho e de pão</li>
      </ul>
      <h3>Comunhão (8 músicas)</h3>
      <ul>
        <li>As promessas do bom pastor</li>
        <li>Esposo ressuscitado</li>
        <li>Ao partir do pão</li>
        <li>Antes da morte e ressurreição de Jesus</li>
        <li>O Senhor preparou um banquete</li>
        <li>Os discípulos de Emaús</li>
        <li>Cristo ressuscitou e nós com Ele</li>
        <li>Celebremos nossa páscoa</li>
      </ul>
      <h3>Extras (4 músicas)</h3>
      <ul>
        <li>Exultat</li>
        <li>Cantai, Cristãos, afinal</li>
        <li>Ressuscitou – corinhos evangélicos</li>
        <li>Celebrai a Cristo, celebrai</li>
      </ul>
    `,
    quantity: 0,
  },
  {
    id: 'cifras-tempo-comum',
    title: 'Cifras de Músicas - Tempo Comum',
    price: 1790,
    originalPrice: 1599,
    image: '/capaEbooksLoja/tempocomum.png',
    category: 'Litúrgico',
    rating: 4.7,
    reviews: 167,
    description: 'Músicas para o tempo comum. O maior tempo litúrgico da igreja.',
    fullDescription: `
      <h3>Entradas (23 músicas)</h3>
      <ul>
        <li>Reunidos aqui</li>
        <li>Vamos celebrar</li>
        <li>Alegres vamos à casa do Pai</li>
        <li>Hoje é tempo de louvar a Deus</li>
        <li>Fico feliz</li>
        <li>Te amarei</li>
        <li>Eis-me aqui, Senhor</li>
        <li>Senhor, quem entrará?</li>
        <li>És água viva</li>
        <li>Eu creio nas promessas de Deus</li>
        <li>Alma missionária</li>
        <li>Dia de festa</li>
        <li>Mestre</li>
        <li>Deixa a luz do céu entrar</li>
        <li>O profeta</li>
        <li>No coração da Igreja</li>
        <li>A alegria da minha juventude</li>
        <li>Estaremos aqui reunidos</li>
        <li>Vem, vem louvar</li>
        <li>De todos cantos viemos</li>
        <li>O Senhor necessitou de braços</li>
        <li>Bom é louvar o Senhor, nosso Deus</li>
        <li>Missão da igreja</li>
      </ul>
      <h3>Ofertório (24 músicas)</h3>
      <ul>
        <li>De mãos estendidas</li>
        <li>Estar em Tuas mãos</li>
        <li>Só em Ti viver</li>
        <li>JMJ – 2013</li>
        <li>Ofertas singelas</li>
        <li>Oferta das bençãos</li>
        <li>Venho, Senhor, oferecer</li>
        <li>Nossa oferta de amor</li>
        <li>Pão e vinho</li>
        <li>A ti, meu Deus</li>
        <li>Minha vida tem sentido</li>
        <li>Um coração para amar</li>
        <li>A mesa Santa</li>
        <li>Bendito seja Deus Pai</li>
        <li>Meu coração é para Ti</li>
        <li>Venho, Senhor, minha vida oferecer</li>
        <li>Venho a Ti</li>
        <li>Dai-lhes vós mesmo de comer</li>
        <li>A liberdade haverá</li>
        <li>Abençoa</li>
        <li>Um consagrado para amar</li>
        <li>Os grãos que formam espigas</li>
        <li>Senhor, meu Deus</li>
        <li>Todo o nosso agir</li>
        <li>A vós, Senhor, apresentamos</li>
      </ul>
      <h3>Comunhão (33 músicas)</h3>
      <ul>
        <li>Pão da vida</li>
        <li>Como És lindo</li>
        <li>Oração pela paz</li>
        <li>Aonde iremos nós?</li>
        <li>Sacramento da comunhão</li>
        <li>Estás entre nós</li>
        <li>Sacramento de amor</li>
        <li>Cantar a beleza da vida</li>
        <li>Pão de igualdade</li>
        <li>Vem e eu mostrarei</li>
        <li>Desamarrem as sandálias</li>
        <li>Vós sois O caminho</li>
        <li>Corpo Santo</li>
        <li>Abraço eterno</li>
        <li>Venho, Senhor</li>
        <li>Vou cantar Teu amor</li>
        <li>Vejam, eu andei pelas vilas</li>
        <li>Verbum Panis</li>
        <li>Jóia rara</li>
        <li>Inigualável comunhão</li>
        <li>Majestosa Eucaristia</li>
        <li>Eterna gratidão</li>
        <li>Pão dos anjos</li>
        <li>Eu sou o pão da vida</li>
        <li>Fonte de viver</li>
        <li>Procuro abrigo</li>
        <li>Deus presente</li>
        <li>Rumo ao altar</li>
        <li>Milagre de amor</li>
        <li>Corpo e sangue</li>
        <li>A barca</li>
        <li>Pelos prados e campinas</li>
        <li>Eu sou o pão</li>
      </ul>
    `,
    quantity: 0,
  },
  {
    id: 'cifras-partes-fixas',
    title: 'Cifras de Músicas - Partes Fixas',
    price: 1790,
    originalPrice: 1599,
    image: '/capaEbooksLoja/musicaspartesfixas.png',
    category: 'Litúrgico',
    rating: 4.5,
    reviews: 112,
    description:
      'Cantos para as partes fixas da Santa Missa: ato penitencial; hino de louvor; Santo; cordeiro; e muito mais!',
    fullDescription: `
      <h3>Ato Penitencial (19 músicas)</h3>
      <ul>
        <li>Eu confesso</li>
        <li>Pelos pecados</li>
        <li>Senhor, vós sois o caminho</li>
        <li>Como a ovelha perdida</li>
        <li>Muito perdoais</li>
        <li>Perdoa-me</li>
        <li>Quero confessar a Ti</li>
        <li>Senhor, que viestes salvar (CN)</li>
        <li>Senhor que viestes salvar</li>
        <li>Kyrie Eleison - JMJ</li>
        <li>Kyrie – Capella</li>
        <li>Coração inquieto</li>
        <li>Compadece-Te</li>
        <li>Eu canto alegria, Senhor</li>
        <li>Senhor, tende piedade</li>
        <li>Senhor, tende piedade de nós (Pe. Pedro Brito)</li>
        <li>Senhor, tende piedade de nós (Léo Mantovani)</li>
        <li>Ó, Senhor, tende piedade</li>
        <li>Confessemos os nossos pecados</li>
      </ul>
      <h3>Hino de Louvor (14 músicas)</h3>
      <ul>
        <li>Glória a Deus nas alturas - Eliana Ribeiro</li>
        <li>Glória, anjos no céu</li>
        <li>Glória, na dança da vida</li>
        <li>Amados por Deus</li>
        <li>Glória, ressuscitou</li>
        <li>Hino de Louvor I</li>
        <li>Hino de Louvor II</li>
        <li>Hino de louvor VI</li>
        <li>Glória a Deus nos altos céus - Ir. Mirian Kolling</li>
        <li>Glória, in excelsis Deo</li>
        <li>Glória a Deus nas alturas – Ney Brasil</li>
        <li>Glória a Deus nas alturas – Toca de Assis</li>
        <li>Glória (João XXIII) – Frei Joel Postma</li>
        <li>Glória a Deus – Adenor João Terra</li>
      </ul>
      <h3>Aclamação ao Evangelho (16 músicas)</h3>
      <ul>
        <li>Aleluia, a minh'alma abrirei</li>
        <li>Aleluia, quando estamos unidos</li>
        <li>Ao ouvir Tua voz</li>
        <li>Aleluia, alguém do povo exclama</li>
        <li>Aleluia, como o Pai me amou</li>
        <li>Buscai primeiro</li>
        <li>Como são belos</li>
        <li>Aleluia – JMJ</li>
        <li>Aleluia, Santo Evangelho</li>
        <li>Vai falar do Evangelho</li>
        <li>Aleluia - CN</li>
        <li>Meu coração transborda de amor</li>
        <li>Aleluia, aleluia, aleluia</li>
        <li>A palavra do Senhor vamos escutar</li>
        <li>Aleluia – Capella</li>
        <li>Aleluia, a palavra do Senhor é viva e eficaz</li>
      </ul>
      <h3>Santo (14 músicas)</h3>
      <ul>
        <li>Santo – Padre Cleidimar</li>
        <li>Santo – Padre Pedro Brito</li>
        <li>Santo, cheios da vossa glória</li>
        <li>Santo – Banda Capella</li>
        <li>Santo – Marco Frisina</li>
        <li>Santo – Canção Nova</li>
        <li>Santo – Adoração e Vida</li>
        <li>Santo é o Senhor – Shalom</li>
        <li>Santo é o Senhor – Shalom (Ressuscitou)</li>
        <li>O Senhor é Santo</li>
        <li>Santo, Santo é</li>
        <li>Santo, Santo, Santo é o Senhor Deus do universo</li>
        <li>Santo, Santo, Santo é o Senhor</li>
        <li>Santo, Senhor Deus do universo</li>
      </ul>
      <h3>Cordeiro (7 músicas)</h3>
      <ul>
        <li>Cordeiro de Deus – Adoração e vida</li>
        <li>Cordeiro de Deus – Shalom</li>
        <li>Cordeiro de Deus</li>
        <li>Cordeiro de Deus que tirais o pecado do mundo – Colo de Deus</li>
        <li>Cordeiro – Padre Tarcísio Pedro Vieira</li>
        <li>Cordeiro de Deus que tirais o pecado do mundo</li>
        <li>Cordeiro – Padre Daniel Nicoline</li>
      </ul>
    `,
    quantity: 0,
  },
  {
    id: 'cifras-adoracao',
    title: 'Cifras de Músicas - Adoração',
    price: 1790,
    originalPrice: 1599,
    image: '/capaEbooksLoja/adoracao.png',
    category: 'Adoração',
    rating: 4.8,
    reviews: 198,
    description: 'Cifras especiais de cantos para o momento de adoração.',
    fullDescription: `
      <h3>33 Músicas de Adoração</h3>
      <ul>
        <li>Tão sublime sacramento</li>
        <li>Alma de Cristo (Anima Christi)</li>
        <li>Diante do Rei</li>
        <li>Jesus está aqui</li>
        <li>Glória a Jesus na hóstia santa</li>
        <li>Ao teu encontro</li>
        <li>Podes reinar</li>
        <li>A Ele a glória</li>
        <li>Em teu altar</li>
        <li>Eu te louvarei</li>
        <li>Adorai</li>
        <li>Em espírito, em verdade</li>
        <li>Só por ti, Jesus</li>
        <li>Estou aqui</li>
        <li>É certo tua presença</li>
        <li>Deus imenso</li>
        <li>Só tu és santo</li>
        <li>Sublime silêncio</li>
        <li>Dá-me tua graça</li>
        <li>Fogo abrasador</li>
        <li>Ares de adoração</li>
        <li>Toda adoração</li>
        <li>Em tua presença</li>
        <li>Jesus, eu te adoro</li>
        <li>Fogo suave</li>
        <li>Te louvo em verdade</li>
        <li>Jesus, te adoro</li>
        <li>Eu quisera</li>
        <li>Só em Deus</li>
        <li>Entra</li>
        <li>Se ninguém te adorar eu vou</li>
        <li>Quem não te louvará?</li>
        <li>Força e vitória</li>
      </ul>
    `,
    quantity: 0,
  },
  {
    id: 'cifras-marianas',
    title: 'Cifras de Músicas - Marianas',
    price: 1790,
    originalPrice: 1599,
    image: '/capaEbooksLoja/marianas.png',
    category: 'Marianas',
    rating: 4.6,
    reviews: 145,
    description: 'Cifras dedicadas a Maria, mãe de Deus e também nossa.',
    fullDescription: `
      <h3>Antífona Mariana (2 músicas)</h3>
      <ul><li>Neste dia, ó Maria</li><li>Salve rainha, mãe de Deus</li></ul>
      <h3>Cantos de Entrada (4 músicas)</h3>
      <ul><li>A escolhida</li><li>Quem é esta que avança como aurora</li><li>A porta do céu</li><li>Tu és a glória de Jerusalém</li></ul>
      <h3>Cantos de Ofertório (2 músicas)</h3>
      <ul><li>Servo por amor</li><li>Como vai ser?</li></ul>
      <h3>Cantos de Comunhão (7 músicas)</h3>
      <ul><li>Povo de Deus foi assim</li><li>Quando teu Pai revelou</li><li>A primeira que comungou</li><li>Eis aí tua mãe</li><li>Maria de Deus, Senhora da paz</li><li>O Senhor fez em mim maravilhas</li><li>Maria do sonho de Deus</li></ul>
      <h3>Cantos Finais (9 músicas)</h3>
      <ul><li>Maria de Nazaré</li><li>Augusta rainha</li><li>Colo de Mãe – Adriana Arydes</li><li>Todo teu</li><li>Pelas estradas da vida</li><li>Imaculada, Maria de Deus</li><li>Com minha mãe estarei</li><li>Senhora e Rainha</li><li>Mãe do novo homem</li></ul>
      <h3>Padroeira do Brasil (5 músicas)</h3>
      <ul><li>Dai-nos a benção</li><li>A padroeira</li><li>Viva a Mãe de Deus e nossa</li><li>Santa Mãe Maria</li><li>Romaria</li><li>Nossa Senhora do Brasil</li></ul>
      <h3>Nossa Senhora de Fátima (1 música)</h3>
      <ul><li>A treze de maio</li></ul>
      <h3>Diversas (15 músicas)</h3>
      <ul><li>Virgem do silêncio</li><li>Maria da minha infância</li><li>Acaso não sabeis</li><li>Cheiro de rosas</li><li>O cântico de Maria</li><li>Um novo céu</li><li>Regaço acolhedor</li><li>Cenáculo de amor</li><li>Colo de Mãe – (Frei Gilson)</li><li>Colo de Mãe – (Colo de Deus)</li><li>Maria e o Anjo</li><li>Porta do céu</li><li>Nossa Senhora</li><li>Coração de Mãe</li><li>Maria, minha mãe, Maria</li></ul>
      <h3>São José (3 músicas)</h3>
      <ul><li>Vinde, alegres cantemos</li><li>Simples José</li><li>Olha que foi, meu bom José</li></ul>
    `,
    quantity: 0,
  },
  {
    id: 'cifras-grupos-oracao',
    title: 'Cifras de Músicas - Grupos de Oração',
    price: 1790,
    originalPrice: 1599,
    image: '/capaEbooksLoja/gruposdeoracao.png',
    category: 'Comunidade',
    rating: 4.7,
    reviews: 156,
    description:
      'Músicas especiais para grupo de oração: Espírito Santo; cura e louvor.',
    fullDescription: `
      <h3>Espírito Santo (14 músicas)</h3>
      <ul>
        <li>Vinde, ó Espírito Santo</li>
        <li>Move-te em mim</li>
        <li>O céu se abre</li>
        <li>Eu navegarei</li>
        <li>Espírito, enche a minha vida</li>
        <li>Sopra em nós</li>
        <li>Queima de novo</li>
        <li>Incendeia minha alma</li>
        <li>Onde o Espírito de Deus está</li>
        <li>Enviai</li>
        <li>Me faz novo</li>
        <li>Vem, Espírito</li>
        <li>Quero mergulhar nas profundezas</li>
        <li>Assim como a corsa</li>
      </ul>
      <h3>Cura (11 músicas)</h3>
      <ul>
        <li>Conheço um coração</li>
        <li>Filho de Davi</li>
        <li>Renova-me</li>
        <li>Oração de cura</li>
        <li>Cura, Senhor</li>
        <li>Neste nome há poder</li>
        <li>Faz um milagre em mim</li>
        <li>Minha essência</li>
        <li>Invocamos</li>
        <li>Vem, ó água viva</li>
        <li>Sangue redentor</li>
      </ul>
      <h3>Louvor (36 músicas)</h3>
      <ul>
        <li>Já chegou, já chegou</li>
        <li>Quero louvar-te</li>
        <li>Vinho novo</li>
        <li>Dança da amizade</li>
        <li>Louvado seja o meu Senhor</li>
        <li>Cristo tem poder</li>
        <li>Passa fogo</li>
        <li>O meu lugar é o céu</li>
        <li>A alegria está no coração</li>
        <li>Erguei as mãos</li>
        <li>O Senhor tem muitos filhos</li>
        <li>Eu quero estar em tuas mãos</li>
        <li>Obra nova</li>
        <li>Iê iê iê</li>
        <li>Tudo por Jesus, nada sem Maria</li>
        <li>Tum-tum-tum de Deus</li>
        <li>Com Jesus é festa</li>
        <li>Canta, povo de Deus</li>
        <li>Bom demais</li>
        <li>Acreditar no amor</li>
        <li>Vem, vem, vem, Espírito Santo</li>
        <li>Deus quero louvar-te</li>
        <li>Derrama o teu amor aqui</li>
        <li>Chuva de graça</li>
        <li>Busque o alto</li>
        <li>O Senhor é rei</li>
        <li>Põe tua mão</li>
        <li>Tomado pela mão</li>
        <li>Senhor, põe teus anjos aqui</li>
        <li>Rei Davi</li>
        <li>Santo, Santo, Santo</li>
        <li>Deus é 10</li>
        <li>O amor</li>
        <li>Restaura nossa casa</li>
        <li>Eu quero um rio</li>
        <li>Vento do Espírito</li>
      </ul>
    `,
    quantity: 0,
  },
  {
    id: 'cifras-infantis',
    title: 'Cifras de Músicas Infantis',
    price: 1790,
    originalPrice: 1599,
    image: '/capaEbooksLoja/musicasinfantis.png',
    category: 'Infantil',
    rating: 4.6,
    reviews: 89,
    description: 'Coletânea de músicas infantis para tocar junto às nossas crianças.',
    fullDescription: `
      <h3>Entrada (3 músicas)</h3>
      <ul><li>Festa da alegria</li><li>A ceia do amor</li><li>Coração de criança</li></ul>
      <h3>Ofertório (3 músicas)</h3>
      <ul><li>Te ofereço minha vida e o que sou</li><li>Ser pequenino</li><li>Oferto a Ti</li></ul>
      <h3>Comunhão (3 músicas)</h3>
      <ul><li>Alegria de viver</li><li>A mesa está preparada</li><li>Na festa da Eucaristia</li></ul>
      <h3>Final (2 músicas)</h3>
      <ul><li>Começou nossa missão</li><li>A missa terminou</li></ul>
      <h3>Marianas (2 músicas)</h3>
      <ul><li>Mãezinha do céu</li><li>Celebrando com Maria</li></ul>
      <h3>Catequese (6 músicas)</h3>
      <ul><li>Esta luz pequenina</li><li>Homenzinho torto</li><li>Pedro, Tiago e João no barquinho</li><li>Anjinho da guarda</li><li>Jesus é meu amigo</li><li>Meu barquinho</li></ul>
      <h3>Diversas (4 músicas)</h3>
      <ul><li>A canoa viorou</li><li>A barata diz que tem</li><li>Borboletinha</li><li>Sambalêlê</li></ul>
    `,
    quantity: 0,
  },
  {
    id: 'cifras-mais-conhecidas',
    title: 'Cifras de Músicas - Mais Conhecidas',
    price: 1790,
    originalPrice: 1599,
    image: '/capaEbooksLoja/maisconhecidas.png',
    category: 'Popular',
    rating: 4.7,
    reviews: 140,
    description:
      'Seleção das músicas mais conhecidas e populares entre nossos leitores.',
    fullDescription: `
      <h3>Adriana Arydes (3 músicas)</h3>
      <ul>
        <li>A chave do coração</li>
        <li>Lindo céu</li>
        <li>Abraço de Pai</li>
      </ul>
      <h3>Anjos de Resgate (4 músicas)</h3>
      <ul>
        <li>Manda teus anjos</li>
        <li>Foi por você</li>
        <li>Tua família</li>
        <li>Eternos amigos</li>
      </ul>
      <h3>Bando Dom (3 músicas)</h3>
      <ul>
        <li>Eu sou o que sou</li>
        <li>Fiat, faça-se</li>
        <li>Coração adorador</li>
      </ul>
      <h3>Celina Borges (2 músicas)</h3>
      <ul>
        <li>Nas asas do Senhor</li>
        <li>Fica, Senhor, comigo</li>
      </ul>
      <h3>Comunidade Colo de Deus (1 música)</h3>
      <ul>
        <li>Yeshua</li>
      </ul>
      <h3>Comunidade Shalom (6 músicas)</h3>
      <ul>
        <li>O teu amor me sustentará</li>
        <li>Eterna união</li>
        <li>A tua ternura</li>
        <li>Eu serei o amor</li>
        <li>Holocausto de amor</li>
        <li>Quem é esse Deus?</li>
      </ul>
      <h3>Davidson Silva (3 músicas)</h3>
      <ul>
        <li>Tomé</li>
        <li>Nada nos separará</li>
        <li>Amar-te mais</li>
      </ul>
      <h3>Eliana Ribeiro (1 música)</h3>
      <ul>
        <li>Barco a vela</li>
      </ul>
      <h3>Fraternidade O Caminho (2 músicas)</h3>
      <ul>
        <li>Para sempre estar aqui</li>
        <li>Seja você</li>
      </ul>
      <h3>Fraternidade São João Paulo II (1 música)</h3>
      <ul>
        <li>Terra seca</li>
      </ul>
      <h3>Frei Gilson (2 músicas)</h3>
      <ul>
        <li>Eu seguirei</li>
        <li>Acalma minha tempestade</li>
      </ul>
      <h3>Irmã Kelly Patrícia (4 músicas)</h3>
      <ul>
        <li>O amado</li>
        <li>Tarde te amei</li>
        <li>Solidão</li>
        <li>Prisioneiro de amor</li>
      </ul>
      <h3>Ir. Míria T. Kolling (1 música)</h3>
      <ul>
        <li>Tudo por causa de um grande amor</li>
      </ul>
      <h3>Juninho Cassimiro (5 músicas)</h3>
      <ul>
        <li>Convívio dos eleitos</li>
        <li>Castelo interior</li>
        <li>O poço</li>
        <li>Santa cruz</li>
        <li>Teus planos</li>
      </ul>
      <h3>Ministério Adoração e vida (1 música)</h3>
      <ul>
        <li>Hoje livre sou</li>
      </ul>
      <h3>Monsenhor Jonas Abib (1 música)</h3>
      <ul>
        <li>O Espírito de Deus</li>
      </ul>
      <h3>Padre Fábio de Melo (5 músicas)</h3>
      <ul>
        <li>Viver pra mim é Cristo</li>
        <li>Tudo é do Pai</li>
        <li>Nunca pare de lutar</li>
        <li>Deus cuida de mim</li>
        <li>Deus é capaz</li>
      </ul>
      <h3>Rinaldo e Samuel (1 música)</h3>
      <ul>
        <li>Sagrado coração</li>
      </ul>
      <h3>Suely Façanaha (2 músicas)</h3>
      <ul>
        <li>O que agrada a Deus</li>
        <li>Com tua mão</li>
      </ul>
      <h3>Thiago Brado (2 músicas)</h3>
      <ul>
        <li>Verdades do tempo</li>
        <li>Meu alvo</li>
      </ul>
      <h3>Toca de Assis (2 músicas)</h3>
      <ul>
        <li>A ovelha sou eu</li>
        <li>Reflexo</li>
      </ul>
      <h3>Diversas (2 músicas)</h3>
      <ul>
        <li>Oração de São Francisco</li>
        <li>Sonda-me</li>
      </ul>
    `,
    quantity: 0,
  },
  {
    id: 'cifras-que-nos-marcaram',
    title: 'Cifras de Músicas que nos Marcaram',
    price: 1790,
    originalPrice: 1599,
    image: '/capaEbooksLoja/musicasmarcantes.png',
    category: 'Popular',
    rating: 4.9,
    reviews: 234,
    description:
      'Dezenas de músicas que marcaram uma geração. Como era bom o nosso tempo!',
    fullDescription: `
      <h3>Padre Zezinho (9 músicas)</h3>
      <ul>
        <li>Um certo galileu</li>
        <li>Amar com Jesus amou</li>
        <li>Estou pensando em Deus</li>
        <li>Utopia</li>
        <li>Há um barco esquecido na praia</li>
        <li>Alô, meu Deus</li>
        <li>O povo de Deus</li>
        <li>Minha luz é Jesus</li>
        <li>Nova geração (eu venho do sul e do norte)</li>
      </ul>
      <h3>Famílias (2 músicas)</h3>
      <ul>
        <li>Oração pela família</li>
        <li>Famílias do Brasil</li>
      </ul>
      <h3>Monsenhor Jonas Abib (3 músicas)</h3>
      <ul>
        <li>A caminhada</li>
        <li>Tudo pode ser mudado</li>
        <li>Eu não quero só dizer amém</li>
      </ul>
      <h3>Padre Marcelo Rossi (5 músicas)</h3>
      <ul>
        <li>Anjos de Deus</li>
        <li>Segura na mão de Deus</li>
        <li>Basta querer</li>
        <li>Pai nosso</li>
        <li>Noites traiçoeiras</li>
      </ul>
      <h3>Eugênio Jorge (2 músicas)</h3>
      <ul>
        <li>Obrigado, Senhor</li>
        <li>Meu Senhor e meu Deus</li>
      </ul>
      <h3>Diversos (9 músicas)</h3>
      <ul>
        <li>Quem me segurou foi Deus</li>
        <li>Eu te chamo, Jesus</li>
        <li>Quem perde sua vida a encontrará</li>
        <li>Ninguém te ama como eu</li>
        <li>O que é que eu sou sem Jesus</li>
        <li>Sim, eu quero</li>
        <li>Quem nos separará</li>
        <li>Eu confio em nosso Senhor</li>
        <li>É missão de todos nós</li>
      </ul>
      <h3>Outros Artistas (6 músicas)</h3>
      <ul>
        <li>Roberto Carlos - Jesus Cristo</li>
        <li>Irmão Lázaro - Meu mestre</li>
        <li>Irmão Lázaro - Eu te amo tanto</li>
        <li>Quão grande és tu (Cânticos Evangélicos)</li>
        <li>Sou um milagre (Cânticos Evangélicos)</li>
        <li>Vaso novo (Cânticos Evangélicos)</li>
      </ul>
    `,
    quantity: 0,
  },
  {
    id: 'cifras-musicas-extras',
    title: 'Cifras de Músicas Extras',
    price: 0,
    originalPrice: 0,
    image: '/capaEbooksLoja/image.png',
    category: 'Extra',
    rating: 4.8,
    reviews: 156,
    description:
      'Coletânea extra de músicas católicas: refrões meditativos, cantos de paz, adoração, batismo, dízimo, bíblia e muito mais! Totalmente gratuito.',
    fullDescription: `
      <h3>Músicas Extras</h3>
      <ul>
        <li>Refrões meditativos</li>
        <li>Cantos de paz</li>
        <li>Adoração</li>
        <li>Batismo</li>
        <li>Dízimo</li>
        <li>Bíblia</li>
      </ul>
    `,
    downloadUrl: '/ebbokspdfs/13-EXTRA.pdf',
    isFree: true,
    quantity: 0,
  },
];

export const findProductById = (id) =>
  PRODUCTS_DATABASE.find((product) => product.id === id);
